import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-angular/';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(private userService: UserService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!isEditorActive()) {
      return this.userService.userHasAccess(state.url.split('?')[0]);
    } else {
      return true;
    }
  }
}
